var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import theme from '../../../theme';
import ActivityTag from '../../../ui/molecules/ActivityTag';
import { Header, HeaderIconContainer, HeaderTitle, HeaderTitleContainer, HeaderWrapper, TagWrapper } from './subcomponents';
import Icon from '../Icon';
var ModalHeaderStrip = function (_a) {
    var title = _a.title, status = _a.status, props = __rest(_a, ["title", "status"]);
    return (_jsxs(Header, __assign({}, props, { children: [_jsx(HeaderIconContainer, { children: _jsx(Icon, { name: "falCreditCard", size: "xl", color: theme.pallete.icon }) }), _jsxs(HeaderWrapper, { children: [_jsx(HeaderTitleContainer, { children: _jsx(HeaderTitle, { children: title }) }), status && (_jsx(TagWrapper, { children: _jsx(ActivityTag, { status: status }) }))] })] })));
};
export default ModalHeaderStrip;
//# sourceMappingURL=index.js.map